import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRegion } from "@/hooks/useRegion";

const REGIONAL_PUBLIC_PATHS = new Set([
  "/", "/about", "/plans", "/faq", "/contact", "/concept-correction", "/clear-terms", "/refund-cancellation-policy",
  "/what-we-do", "/what-we-dont", "/why-this-matters", "/terms-and-conditions", "/privacy-policy", "/cookie-policy", "/business-information",
]);

function supportsRegionalPath(pathname) {
  return REGIONAL_PUBLIC_PATHS.has(pathname) || pathname.startsWith("/plans/");
}

export default function RegionRouteSync() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { region } = useRegion();

  useEffect(() => {
    if (region === "ph" && !pathname.startsWith("/ph") && supportsRegionalPath(pathname)) {
      navigate(`${pathname === "/" ? "/ph" : `/ph${pathname}`}${search}`, { replace: true });
    }
  }, [navigate, pathname, region, search]);

  return null;
}